import { z } from 'zod';

export const formSchema = z.object({
  companyId: z.array(z.string()).optional(),
  productBatch: z.string().optional(),
  productSku: z.string().optional(),
  productDescription: z.string().optional(),
  equipmentCode: z.string().optional(),
  eventDate: z
    .object({
      from: z.date().optional(),
      to: z.date().optional(),
    })
    .optional(),
  temperature: z.array(z.string()).optional(),
});

 export type FormSchema = z.infer<typeof formSchema>;
